"use client";
import { useEffect, useState, type FormEvent } from "react";
import { useRouter } from "next/navigation";
import { Alert, Button, Field, Input, Segment } from "@openhiggsfield/design";
import { api } from "@/projects/api";
import { useSession } from "@/shell/workspace-shell";
import { AuthShowcase } from "./auth-showcase";
export function AuthPage() {
  const [mode, setMode] = useState("login"),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  const router = useRouter(),
    session = useSession();
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const data = Object.fromEntries(new FormData(event.currentTarget));
    try {
      const result = await api<{user:{admin:boolean}}>(`auth/${mode}`, { method: "POST", body: JSON.stringify(data) });
      await session.refresh();
      router.push(result.user.admin ? "/admin" : "/projects");
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <main className="ws-auth">
      <section className="ws-auth-story">
        <span className="ws-eyebrow">DREAM STUDIO · AI 콘텐츠 작업실</span>
        <h1>
          상상한 장면을,
          <br /><em>완성된 콘텐츠로.</em>
        </h1>
        <p>
          카드뉴스부터 숏폼, 랜딩 페이지와 제품 상세 페이지까지.
          <br />
          아이디어를 적고, AI와 함께 만들고, 직접 완성하세요.
        </p>
        <AuthShowcase />
      </section>
      <form method="post" onSubmit={submit} className="ws-form">
        <h2>
          {mode === "login"
            ? "만들던 꿈을 이어가세요"
            : "첫 아이디어를 시작하세요"}
        </h2>
        <p className="ws-muted">
          {mode === "login"
            ? "저장한 프로젝트를 열고, 다음 장면을 완성하세요."
            : "나만의 작업실에 아이디어와 결과물을 모아보세요."}
        </p>
        <Segment
          aria-label="계정 시작"
          items={[
            { id: "login", label: "로그인" },
            { id: "register", label: "회원가입" },
          ]}
          value={mode}
          onChange={setMode}
          plate
        />
        {mode === "register" && (
          <Field label="이름" htmlFor="name">
            <Input
              id="name"
              name="name"
              required
              maxLength={50}
              autoComplete="name"
            />
          </Field>
        )}
        <Field label={mode === "login" ? "아이디 또는 이메일" : "이메일"} htmlFor="email">
          <Input
            id="email"
            name="email"
            type={mode === "login" ? "text" : "email"}
            required
            autoComplete="username"
            maxLength={254}
          />
        </Field>
        <Field
          label="비밀번호"
          htmlFor="password"
          hint={mode === "register" ? "10자 이상으로 설정하세요." : undefined}
        >
          <Input
            id="password"
            name="password"
            type="password"
            required
            minLength={mode === "register" ? 10 : 1}
            maxLength={128}
            autoComplete={
              mode === "register" ? "new-password" : "current-password"
            }
          />
        </Field>
        {error && <Alert>{error}</Alert>}
        <Button type="submit" variant="primary" size="lg" loading={busy} disabled={!ready}>
          {mode === "register" ? "작업실 만들기" : "로그인"}
        </Button>
        <p className="ws-muted">
          편집과 파일 내보내기는 무료입니다.
          <br />AI 생성에는 크레딧을 사용합니다.
        </p>
      </form>
    </main>
  );
}
